const KVKKPage = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      {/* Hero Section */}
      <section className="relative py-20 md:py-32 bg-gradient-to-br from-gray-900 via-black to-gray-800 overflow-hidden">
        <div className="absolute inset-0 opacity-20">
          <div className="absolute top-0 right-0 w-96 h-96 bg-gradient-to-l from-gray-400 to-transparent rounded-full blur-3xl"></div>
          <div className="absolute bottom-0 left-0 w-96 h-96 bg-gradient-to-r from-gray-500 to-transparent rounded-full blur-3xl"></div>
        </div>

        <div className="container mx-auto px-4 md:px-6 relative z-10 text-center">
          <h1 className="text-3xl md:text-5xl lg:text-6xl font-extrabold text-gray-100 mb-4">
            KVKK
            <span className="block mt-3 md:mt-4 bg-gradient-to-r from-gray-300 via-gray-100 to-gray-400 bg-clip-text text-transparent">
              Kişisel Verilerin Korunması
            </span>
          </h1>
        </div>
      </section>

      {/* Content Section */}
      <section className="py-12 md:py-24">
        <div className="container mx-auto px-4 md:px-6 max-w-4xl">
          <div className="bg-gray-100 rounded-3xl shadow-xl p-6 md:p-12 space-y-8">
            <div>
              <h2 className="text-2xl md:text-3xl font-bold text-black mb-4">1. Veri Sorumlusu</h2>
              <p className="text-gray-700 leading-relaxed text-sm md:text-base">
                S&K Shine Works Detailing olarak, 6698 sayılı Kişisel Verilerin Korunması Kanunu ("KVKK") uyarınca veri sorumlusu sıfatıyla, kişisel verilerinizi aşağıda açıklanan kapsamda işlemekteyiz.
              </p>
            </div>

            <div>
              <h2 className="text-2xl md:text-3xl font-bold text-black mb-4">2. İşlenen Kişisel Veriler</h2>
              <p className="text-gray-700 leading-relaxed mb-4 text-sm md:text-base">
                Hizmetlerimizden faydalanmanız sırasında aşağıdaki kişisel verileriniz işlenebilmektedir:
              </p>
              <ul className="list-disc list-inside space-y-2 text-gray-700 text-sm md:text-base">
                <li>Kimlik Bilgileri (Ad, Soyad)</li>
                <li>İletişim Bilgileri (Telefon Numarası, E-posta Adresi)</li>
                <li>Müşteri İşlem Bilgileri (Randevu Bilgileri, Hizmet Talepleri)</li>
                <li>Araç Bilgileri (Plaka, Marka, Model)</li>
              </ul>
            </div>

            <div>
              <h2 className="text-2xl md:text-3xl font-bold text-black mb-4">3. Kişisel Verilerin İşlenme Amaçları</h2>
              <p className="text-gray-700 leading-relaxed mb-4 text-sm md:text-base">
                Kişisel verileriniz aşağıdaki amaçlarla işlenmektedir:
              </p>
              <ul className="list-disc list-inside space-y-2 text-gray-700 text-sm md:text-base">
                <li>Randevu oluşturma ve yönetimi</li>
                <li>Hizmet kalitesinin artırılması</li>
                <li>Müşteri memnuniyetinin sağlanması</li>
                <li>İletişim faaliyetlerinin yürütülmesi</li>
                <li>Yasal yükümlülüklerin yerine getirilmesi</li>
              </ul>
            </div>

            <div>
              <h2 className="text-2xl md:text-3xl font-bold text-black mb-4">4. Kişisel Verilerin Aktarılması</h2>
              <p className="text-gray-700 leading-relaxed text-sm md:text-base">
                Kişisel verileriniz, KVKK'nın 8. ve 9. maddelerinde belirtilen şartlara uygun olarak, hizmet sağlayıcılarımız ve iş ortaklarımızla paylaşılabilir. Verileriniz yurt dışına aktarılmamaktadır.
              </p>
            </div>

            <div>
              <h2 className="text-2xl md:text-3xl font-bold text-black mb-4">5. Kişisel Veri Toplamanın Yöntemi</h2>
              <p className="text-gray-700 leading-relaxed text-sm md:text-base">
                Kişisel verileriniz, web sitemiz üzerinden doldurduğunuz formlar, telefon görüşmeleri, e-posta iletişimi ve fiziksel ziyaretleriniz sırasında toplanmaktadır.
              </p>
            </div>

            <div>
              <h2 className="text-2xl md:text-3xl font-bold text-black mb-4">6. Kişisel Veri Sahibinin Hakları</h2>
              <p className="text-gray-700 leading-relaxed mb-4 text-sm md:text-base">
                KVKK'nın 11. maddesi uyarınca, kişisel veri sahipleri olarak aşağıdaki haklara sahipsiniz:
              </p>
              <ul className="list-disc list-inside space-y-2 text-gray-700 text-sm md:text-base">
                <li>Kişisel verilerinizin işlenip işlenmediğini öğrenme</li>
                <li>Kişisel verileriniz işlenmişse buna ilişkin bilgi talep etme</li>
                <li>Kişisel verilerin işlenme amacını ve bunların amacına uygun kullanılıp kullanılmadığını öğrenme</li>
                <li>Yurt içinde veya yurt dışında kişisel verilerin aktarıldığı üçüncü kişileri bilme</li>
                <li>Kişisel verilerin eksik veya yanlış işlenmiş olması hâlinde bunların düzeltilmesini isteme</li>
                <li>KVKK'nın 7. maddesinde öngörülen şartlar çerçevesinde kişisel verilerin silinmesini veya yok edilmesini isteme</li>
                <li>Kişisel verilerin düzeltilmesi, silinmesi veya yok edilmesi halinde bu işlemlerin kişisel verilerin aktarıldığı üçüncü kişilere bildirilmesini isteme</li>
                <li>İşlenen verilerin münhasıran otomatik sistemler vasıtasıyla analiz edilmesi suretiyle aleyhinize bir sonucun ortaya çıkmasına itiraz etme</li>
                <li>Kişisel verilerin kanuna aykırı olarak işlenmesi sebebiyle zarara uğraması hâlinde zararın giderilmesini talep etme</li>
              </ul>
            </div>

            <div>
              <h2 className="text-2xl md:text-3xl font-bold text-black mb-4">7. İletişim</h2>
              <p className="text-gray-700 leading-relaxed text-sm md:text-base">
                KVKK kapsamındaki taleplerinizi, kimliğinizi tespit edici belgeler ile birlikte aşağıdaki iletişim kanalları üzerinden bize iletebilirsiniz:
              </p>
              <div className="mt-4 space-y-2 text-gray-700 text-sm md:text-base">
                <p><strong>Adres:</strong> 677/12. Sk. 40A, 35380 İzmir, Buca</p>
                <p><strong>Telefon:</strong> 0505 049 87 11</p>
              </div>
            </div>

            <div className="pt-6 border-t border-gray-300">
              <p className="text-gray-600 text-xs md:text-sm">
                Son Güncelleme: {new Date().toLocaleDateString('tr-TR')}
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* WhatsApp Floating Button */}
      <a
        href="https://wa.me/905050498711?text=Merhaba,%20SKDetailing.com.tr%20üzerinden%20iletişime%20geçiyorum."
        target="_blank"
        rel="noopener noreferrer"
        className="fixed bottom-6 md:bottom-8 right-6 md:right-8 w-14 h-14 md:w-16 md:h-16 flex items-center justify-center bg-[#25D366] rounded-full shadow-2xl hover:scale-110 hover:shadow-green-500/50 transition-all duration-300 z-50 cursor-pointer group"
        aria-label="WhatsApp"
      >
        <i className="ri-whatsapp-line text-2xl md:text-3xl text-gray-100 group-hover:text-gray-200"></i>
      </a>
    </div>
  );
};

export default KVKKPage;
